// SVG Path Parsing utilities
function subdivideQuadratic(p0, cp, p1, steps) {
    const points = [];
    for(let i = 1; i <= steps; i++){
        const t = i / steps;
        const mt = 1 - t;
        points.push({
            x: mt * mt * p0.x + 2 * mt * t * cp.x + t * t * p1.x,
            y: mt * mt * p0.y + 2 * mt * t * cp.y + t * t * p1.y
        });
    }
    return points;
}
function subdivideCubic(opts, steps) {
    const { p0, cp1, cp2, p1 } = opts;
    const points = [];
    for(let i = 1; i <= steps; i++){
        const t = i / steps;
        const mt = 1 - t;
        points.push({
            x: mt * mt * mt * p0.x + 3 * mt * mt * t * cp1.x + 3 * mt * t * t * cp2.x + t * t * t * p1.x,
            y: mt * mt * mt * p0.y + 3 * mt * mt * t * cp1.y + 3 * mt * t * t * cp2.y + t * t * t * p1.y
        });
    }
    return points;
}
const SVG_CMD_RE = /([MLHVQCASTZmlhvqcastz])([^MLHVQCASTZmlhvqcastz]*)/g;
function parseNumbers(s) {
    const matches = s.match(/-?\d+(?:\.\d+)?(?:e[+-]?\d+)?/gi);
    return matches ? matches.map(Number) : [];
}
const CURVE_SUBDIVISION_STEPS = 8;
function pointsToSegments(start, points, segments) {
    let prev = start;
    for (const p of points){
        segments.push({
            x1: prev.x,
            y1: prev.y,
            x2: p.x,
            y2: p.y
        });
        prev = p;
    }
}
function linearInterpolateSegments(start, end, steps, segments) {
    let prev = start;
    for(let s = 1; s <= steps; s++){
        const t = s / steps;
        const px = start.x + (end.x - start.x) * t;
        const py = start.y + (end.y - start.y) * t;
        segments.push({
            x1: prev.x,
            y1: prev.y,
            x2: px,
            y2: py
        });
        prev = {
            x: px,
            y: py
        };
    }
}
function handleMoveCmd(nums, isRelative, state, segments) {
    const x = isRelative ? state.cx + nums[0] : nums[0];
    const y = isRelative ? state.cy + nums[1] : nums[1];
    state.cx = x;
    state.cy = y;
    state.startX = x;
    state.startY = y;
    for(let i = 2; i < nums.length; i += 2){
        const nx = isRelative ? state.cx + nums[i] : nums[i];
        const ny = isRelative ? state.cy + nums[i + 1] : nums[i + 1];
        segments.push({
            x1: state.cx,
            y1: state.cy,
            x2: nx,
            y2: ny
        });
        state.cx = nx;
        state.cy = ny;
    }
}
function handleLineCmd(nums, isRelative, state, segments) {
    for(let i = 0; i < nums.length; i += 2){
        const x = isRelative ? state.cx + nums[i] : nums[i];
        const y = isRelative ? state.cy + nums[i + 1] : nums[i + 1];
        segments.push({
            x1: state.cx,
            y1: state.cy,
            x2: x,
            y2: y
        });
        state.cx = x;
        state.cy = y;
    }
}
function handleHorzCmd(nums, isRelative, state, segments) {
    for (const n of nums){
        const x = isRelative ? state.cx + n : n;
        segments.push({
            x1: state.cx,
            y1: state.cy,
            x2: x,
            y2: state.cy
        });
        state.cx = x;
    }
}
function handleVertCmd(nums, isRelative, state, segments) {
    for (const n of nums){
        const y = isRelative ? state.cy + n : n;
        segments.push({
            x1: state.cx,
            y1: state.cy,
            x2: state.cx,
            y2: y
        });
        state.cy = y;
    }
}
function handleQuadCmd(nums, isRelative, state, segments) {
    for(let i = 0; i < nums.length; i += 4){
        const cpx = isRelative ? state.cx + nums[i] : nums[i];
        const cpy = isRelative ? state.cy + nums[i + 1] : nums[i + 1];
        const x = isRelative ? state.cx + nums[i + 2] : nums[i + 2];
        const y = isRelative ? state.cy + nums[i + 3] : nums[i + 3];
        const pts = subdivideQuadratic({
            x: state.cx,
            y: state.cy
        }, {
            x: cpx,
            y: cpy
        }, {
            x,
            y
        }, CURVE_SUBDIVISION_STEPS);
        pointsToSegments({
            x: state.cx,
            y: state.cy
        }, pts, segments);
        state.cx = x;
        state.cy = y;
        state.lastQcpx = cpx;
        state.lastQcpy = cpy;
    }
}
function handleCubicCmd(nums, isRelative, state, segments) {
    for(let i = 0; i < nums.length; i += 6){
        const cp1x = isRelative ? state.cx + nums[i] : nums[i];
        const cp1y = isRelative ? state.cy + nums[i + 1] : nums[i + 1];
        const cp2x = isRelative ? state.cx + nums[i + 2] : nums[i + 2];
        const cp2y = isRelative ? state.cy + nums[i + 3] : nums[i + 3];
        const x = isRelative ? state.cx + nums[i + 4] : nums[i + 4];
        const y = isRelative ? state.cy + nums[i + 5] : nums[i + 5];
        const pts = subdivideCubic({
            p0: {
                x: state.cx,
                y: state.cy
            },
            cp1: {
                x: cp1x,
                y: cp1y
            },
            cp2: {
                x: cp2x,
                y: cp2y
            },
            p1: {
                x,
                y
            }
        }, CURVE_SUBDIVISION_STEPS);
        pointsToSegments({
            x: state.cx,
            y: state.cy
        }, pts, segments);
        state.cx = x;
        state.cy = y;
        state.lastCp2x = cp2x;
        state.lastCp2y = cp2y;
    }
}
function handleSmoothCubicCmd(nums, isRelative, state, segments) {
    for(let i = 0; i < nums.length; i += 4){
        const cp1x = state.lastCmd === "C" || state.lastCmd === "S" ? 2 * state.cx - state.lastCp2x : state.cx;
        const cp1y = state.lastCmd === "C" || state.lastCmd === "S" ? 2 * state.cy - state.lastCp2y : state.cy;
        const cp2x = isRelative ? state.cx + nums[i] : nums[i];
        const cp2y = isRelative ? state.cy + nums[i + 1] : nums[i + 1];
        const x = isRelative ? state.cx + nums[i + 2] : nums[i + 2];
        const y = isRelative ? state.cy + nums[i + 3] : nums[i + 3];
        const pts = subdivideCubic({
            p0: {
                x: state.cx,
                y: state.cy
            },
            cp1: {
                x: cp1x,
                y: cp1y
            },
            cp2: {
                x: cp2x,
                y: cp2y
            },
            p1: {
                x,
                y
            }
        }, CURVE_SUBDIVISION_STEPS);
        pointsToSegments({
            x: state.cx,
            y: state.cy
        }, pts, segments);
        state.cx = x;
        state.cy = y;
        state.lastCp2x = cp2x;
        state.lastCp2y = cp2y;
        state.lastCmd = "S";
    }
}
function handleSmoothQuadCmd(nums, isRelative, state, segments) {
    for(let i = 0; i < nums.length; i += 2){
        const cpx = state.lastCmd === "Q" || state.lastCmd === "T" ? 2 * state.cx - state.lastQcpx : state.cx;
        const cpy = state.lastCmd === "Q" || state.lastCmd === "T" ? 2 * state.cy - state.lastQcpy : state.cy;
        const x = isRelative ? state.cx + nums[i] : nums[i];
        const y = isRelative ? state.cy + nums[i + 1] : nums[i + 1];
        const pts = subdivideQuadratic({
            x: state.cx,
            y: state.cy
        }, {
            x: cpx,
            y: cpy
        }, {
            x,
            y
        }, CURVE_SUBDIVISION_STEPS);
        pointsToSegments({
            x: state.cx,
            y: state.cy
        }, pts, segments);
        state.cx = x;
        state.cy = y;
        state.lastQcpx = cpx;
        state.lastQcpy = cpy;
        state.lastCmd = "T";
    }
}
function handleArcCmd(nums, isRelative, state, segments) {
    for(let i = 0; i < nums.length; i += 7){
        const x = isRelative ? state.cx + nums[i + 5] : nums[i + 5];
        const y = isRelative ? state.cy + nums[i + 6] : nums[i + 6];
        linearInterpolateSegments({
            x: state.cx,
            y: state.cy
        }, {
            x,
            y
        }, CURVE_SUBDIVISION_STEPS, segments);
        state.cx = x;
        state.cy = y;
    }
}
/**
 * Parse an SVG path string into an array of LineSegments.
 * Supports M, L, H, V, Q, C, A, Z commands (absolute and relative).
 */ export function pathToSegments(svgPath) {
    const segments = [];
    const state = {
        cx: 0,
        cy: 0,
        startX: 0,
        startY: 0,
        lastCp2x: 0,
        lastCp2y: 0,
        lastQcpx: 0,
        lastQcpy: 0,
        lastCmd: ""
    };
    let match;
    SVG_CMD_RE.lastIndex = 0;
    while((match = SVG_CMD_RE.exec(svgPath)) !== null){
        const cmd = match[1];
        const nums = parseNumbers(match[2]);
        const isRelative = cmd === cmd.toLowerCase();
        const upperCmd = cmd.toUpperCase();
        switch(upperCmd){
            case "M":
                handleMoveCmd(nums, isRelative, state, segments);
                break;
            case "L":
                handleLineCmd(nums, isRelative, state, segments);
                break;
            case "H":
                handleHorzCmd(nums, isRelative, state, segments);
                break;
            case "V":
                handleVertCmd(nums, isRelative, state, segments);
                break;
            case "Q":
                handleQuadCmd(nums, isRelative, state, segments);
                break;
            case "C":
                handleCubicCmd(nums, isRelative, state, segments);
                break;
            case "S":
                handleSmoothCubicCmd(nums, isRelative, state, segments);
                break;
            case "T":
                handleSmoothQuadCmd(nums, isRelative, state, segments);
                break;
            case "A":
                handleArcCmd(nums, isRelative, state, segments);
                break;
            case "Z":
                {
                    if (state.cx !== state.startX || state.cy !== state.startY) {
                        segments.push({
                            x1: state.cx,
                            y1: state.cy,
                            x2: state.startX,
                            y2: state.startY
                        });
                    }
                    state.cx = state.startX;
                    state.cy = state.startY;
                    break;
                }
        }
        state.lastCmd = upperCmd;
    }
    return mergeCollinearSegments(segments);
}
function mergeCollinearSegments(segments) {
    if (segments.length <= 1) return segments;
    const merged = [
        {
            ...segments[0]
        }
    ];
    for(let i = 1; i < segments.length; i++){
        const prev = merged[merged.length - 1];
        const curr = segments[i];
        const currLen = Math.abs(curr.x2 - curr.x1) + Math.abs(curr.y2 - curr.y1);
        if (currLen < 0.1) continue;
        const prevIsH = Math.abs(prev.y2 - prev.y1) < 0.5 && Math.abs(prev.x2 - prev.x1) > 0.1;
        const currIsH = Math.abs(curr.y2 - curr.y1) < 0.5 && Math.abs(curr.x2 - curr.x1) > 0.1;
        const prevIsV = Math.abs(prev.x2 - prev.x1) < 0.5 && Math.abs(prev.y2 - prev.y1) > 0.1;
        const currIsV = Math.abs(curr.x2 - curr.x1) < 0.5 && Math.abs(curr.y2 - curr.y1) > 0.1;
        const endpointsConnect = Math.abs(prev.x2 - curr.x1) < 0.5 && Math.abs(prev.y2 - curr.y1) < 0.5;
        const sameDirectionH = prevIsH && currIsH && Math.sign(prev.x2 - prev.x1) === Math.sign(curr.x2 - curr.x1);
        const sameDirectionV = prevIsV && currIsV && Math.sign(prev.y2 - prev.y1) === Math.sign(curr.y2 - curr.y1);
        if (endpointsConnect && (sameDirectionH || sameDirectionV)) {
            prev.x2 = curr.x2;
            prev.y2 = curr.y2;
        } else {
            merged.push({
                ...curr
            });
        }
    }
    return merged;
}

//# sourceMappingURL=svgPathParser.js.map